export default __webpack_public_path__ + "static/media/curieux.c82a834f.png";